import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { branch } from 'baobab-react/higher-order';
import Feature from '../common/Feature';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';

import Hero from './common/Hero';
import TrustedSection from './common/TrustedSection';
import TopProducts from './common/TopProducts';
import TotalProductCount from './common/TotalProductCount';

class Category extends Component {
	render() {
		const pageTitle = 'Business Safes';
		const totalCount = this.props.category.productCount;
		let topProducts;
		// eslint-disable-next-line eqeqeq
		if (this.props.featuredProduct != null) {
			topProducts = (
				<TopProducts
					title={ `Best Selling ${pageTitle}` }
					subTitle="Unique security features for your business needs"
					path="business-safes"
					buttonCTA={ `View all ${pageTitle}` }
					topProduct={ this.props.featuredProduct }
				/>
			);
		}

		return (
			<div className="category category-business">
				<Helmet>
					<title>{ pageTitle } &#124; SentrySafe</title>
					<meta name="description" content="Our business safes are designed with powerful anti-theft features to provide peace-of-mind. View business safes." />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem path="/products" label="Products" />
					<BreadcrumbItem label={ pageTitle } />
				</Breadcrumb>

				<Hero
					imageSrc={ require('../../resources/img/hero/business-safes.jpg') }
					imageAlt="Man taking an order at counter"
					title={ pageTitle }
					description="Protect your business assets from theft and more."
				/>

				<TrustedSection
					content="When you&rsquo;re running a business, the last thing you want to worry about is theft. And with SentrySafe Business Safes, you don&rsquo;t have to. Our safes are uniquely designed to protect cash, receipts, deposit slips, keys and other valuables against theft and burglaries at the point of purchase. Plus, we offer business safes that also provide protection from fire and fire and water, ensuring your important paperwork, cash and other valuables are safe and secure. You can focus on your business, your employees and your customers."
				/>

				{ topProducts }

				<section className="row features">
					<div className="col">
						<h2 className="title">Security for Multiple Users</h2>
						<p>You depend on your employees to help you keep your business secure. That&rsquo;s why SentrySafe Business Safes are designed with multiple users in mind.</p>
					</div>
					<div className="callouts">
						<Feature
							title="Digital Lock"
							description="Programmable digital locks let you choose a combination that works for you and your team."
							image={ require('../../resources/img/features/digital-lock.png') }
						/>
						<Feature
							title="Anti-fish Hopper"
							description="Anti-fish hoppers prevent cash and deposits from being stolen during storage."
							image={ require('../../resources/img/features/anti-fish-hopper.png') }
						/>
					</div>
				</section>

				<section className="row features">
					<div className="col">
						<h2 className="title">Powerful Anti-Theft Features</h2>
					</div>
					<div className="callouts">
						<Feature
							title="Delay Mode"
							description="Our digital lock goes into delay mode when multiple wrong combination attempts are entered."
							image={ require('../../resources/img/features/digital-lock.png') }
						/>
						<Feature
							title="Hardened Steel Plate"
							description="Hardened steel plates protect cash and deposits against drill attacks."
							image={ require('../../resources/img/features/steel-construction.png') }
						/>
						<Feature
							title="Bolt-down Hardware"
							description="Bolt-down hardware ensures thieves can&rsquo;t easily remove your safe from your business."
							image={ require('../../resources/img/features/bolt-down.png') }
						/>
					</div>
				</section>

				<TotalProductCount
					link="business-safes"
					productTotal={ totalCount }
					name={ pageTitle }
				/>
			</div>
		);
	}
}

export default branch({
	category: ['category'],
	featuredProduct: ['category', 'featuredProduct', 'products']
}, Category);


// WEBPACK FOOTER //
// ./src/pages/category/BusinessCategory.js